// PT-01: honest-UX warning banner shown beneath the navbar in paper mode.
// PT-02 removes this once IBKR position sync ships and paper-mode data is
// real. Returns null in live mode — no DOM, no layout shift.

import { FlaskConical } from 'lucide-react'
import { useMode } from '../hooks/useMode'

export default function PaperModeBanner() {
  const { mode } = useMode()
  if (mode !== 'paper') return null
  return (
    <div
      role="status"
      className="sticky top-0 z-20 w-full border-b border-[#4a90e2]/30 bg-[#4a90e2]/10 text-[#4a90e2]"
    >
      <div className="px-4 md:px-8 py-2 flex items-start md:items-center gap-2 font-mono text-[11px] leading-snug">
        <FlaskConical size={12} className="shrink-0 mt-0.5 md:mt-0" />
        <p className="m-0">
          <strong className="font-semibold">Paper Mode active.</strong>{' '}
          IBKR position sync ships in PT-02 — data displayed below is still from
          your live Schwab connection until that slice lands.
        </p>
      </div>
    </div>
  )
}
